{
	"title": "Progetti",
	"table": {
		"reference": "Riferimento",
		"quantity": "Quantità totale",
		"savings": "Riduzioni totali di carbonio",
		"fetchError": "Impossibile recuperare i progetti"
	},
	"showProjectsHistoryTitle": "Mostra cronologia progetti",
	"noProjects": {
		"createDeclaration": "Crea la tua prima dichiarazione",
		"description": "Puoi creare dichiarazioni per uno o più materiali facendo clic su «Crea dichiarazione»."
	}
}
